<div class="flex h-full w-full flex-col">
  <div class="mb-6 mt-6 flex h-11 w-full flex-shrink-0 flex-row items-center">
    <div
      class="text-s1 ml-[36px] min-w-[2px] max-w-max flex-grow truncate text-lg"
      >{{ file?.name }}</div
    >

    <div
      tp="Selected file has error"
      [tpIsEnabled]="isSelectedFileValid === false"
    >
      <button
        class="ml-5 flex flex-shrink-0 flex-row items-center focus:outline-none"
        [ngClass]="{
          'text-s400': isSelectedFileValid === false,
          'text-m600': isSelectedFileValid === true
        }"
        *ngIf="
          showGoTo === true &&
          ((member?.isExplorer === true &&
            ((file?.name | goFromFileExt) === 'chart' ||
              (file?.name | goFromFileExt) === 'malloy' ||
              (file?.name | goFromFileExt) === 'store')) ||
            (file?.name | goFromFileExt) === 'dashboard' ||
            (file?.name | goFromFileExt) === 'report')
        "
        (click)="goTo()"
        [disabled]="isSelectedFileValid === false"
      >
        <m-arrow-narrow-right-icon></m-arrow-narrow-right-icon>

        <div class="ml-2 text-lg">
          {{
            (file?.name | goFromFileExt) === 'malloy' ||
            (file?.name | goFromFileExt) === 'store'
              ? 'Model'
              : (file?.name | goFromFileExt | capitalize)
          }}</div
        >
      </button>
    </div>

    <div class="flex flex-1"></div>

    <ng-template #templateSave>
      <div *ngIf="needSave === false">No changes to Save</div>
    </ng-template>

    <div
      *ngIf="nav?.repoType === repoTypeEnum.Production"
      class="ml-5 mr-6 flex flex-shrink-0 flex-col font-semibold"
    >
      <div class="flex select-none text-[17px] text-gray-500">
        To make changes, select the dev repo branch
      </div>
    </div>

    <div
      class="ml-5 flex flex-shrink-0"
      *ngIf="nav?.repoType !== repoTypeEnum.Production"
      [tp]="templateSave"
      [tpIsEnabled]="needSave === false"
    >
      <button
        type="button"
        data-cy="fileEditorSaveButton"
        class="text-m0 h-11 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
        [ngClass]="{
          'bg-s400 cursor-default': !needSave,
          'bg-m600': needSave
        }"
        (click)="save()"
        [disabled]="!needSave"
        >Save and Validate</button
      >
    </div>

    <ng-template #templateCancel>
      <div *ngIf="needSave === false">No changes to cancel</div>
    </ng-template>

    <div
      class="ml-3 mr-6 flex flex-shrink-0"
      *ngIf="nav?.repoType !== repoTypeEnum.Production"
      [tp]="templateCancel"
      [tpIsEnabled]="needSave === false"
    >
      <button
        class=""
        *ngIf="nav?.repoType !== repoTypeEnum.Production"
        type="button"
        data-cy="fileEditorCancelButton"
        class="flex h-11 flex-shrink-0 select-none rounded border px-5 py-2 text-base font-medium focus:outline-none"
        [ngClass]="{
          'border-s400 text-s400 cursor-default': !needSave,
          'border-m600 text-m600': needSave
        }"
        (click)="cancel()"
        [disabled]="!needSave"
        >Cancel</button
      >
    </div>
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div class="flex h-2 w-full flex-grow flex-row pl-6 pr-6">
    <div
      *ngIf="
        builderLeft === builderLeftTree &&
        isEditorOptionsInitComplete === true &&
        content != null &&
        !!file?.fileNodeId
      "
      class="flex w-2 flex-1"
    >
      <code-editor
        #codeEditor
        class="w-full outline-none"
        data-cy="fileEditorCodeEditor"
        style="height: 100%"
        [(ngModel)]="content"
        [readonly]="
          nav?.repoType === repoTypeEnum.Production || file?.isExist === false
        "
        [extensions]="mainExtensions"
        [languages]="languages"
        [language]="lang"
        [theme]="theme"
        [setup]="null"
        [indentWithTab]="indentWithTab"
        [indentUnit]="indentUnit"
        (ngModelChange)="onTextChanged({ isDiffEditor: false })"
      ></code-editor>
    </div>

    <div
      class="flex w-2 flex-1"
      *ngIf="
        showDiff === true &&
        builderLeft !== builderLeftTree &&
        isEditorOptionsInitComplete === true &&
        !!originalExtensions &&
        !!modifiedExtensions
      "
    >
      <diff-editor
        #diffEditor
        class="w-full outline-none"
        style="height: 100%"
        [setup]="null"
        [(ngModel)]="diffContent"
        [originalExtensions]="originalExtensions"
        [modifiedExtensions]="modifiedExtensions"
        [disabled]="
          nav?.repoType === repoTypeEnum.Production || file?.isExist === false
        "
        (originalValueChange)="onOriginalTextChanged()"
        (modifiedValueChange)="onTextChanged({ isDiffEditor: true })"
      ></diff-editor>
    </div>
  </div>
</div>

<div *ngIf="isHighlighterReady$ | async"></div>
<div *ngIf="builderLeft$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="file$ | async"></div>
<div *ngIf="repo$ | async"></div>
<div *ngIf="struct$ | async"></div>
<div *ngIf="routeLine$ | async"></div>
<div *ngIf="fileId$ | async"></div>
<div *ngIf="member$ | async"></div>
